module.exports = __webpack_public_path__ + "static/media/back-to-top.98c82c72.svg";